import React from 'react';

interface IEmployerArticleProps {
    id: number;
    segmentName: string;
    logoUrl: string;
    logoAlt: string;
    name: string;
    shortDescription: string;
    homepageUrl: string;
    employerDetailPage: string;
}

export function EmployerArticle(content: IEmployerArticleProps) {
    return (
        <div className="col-12 col-md-6 col-lg-4 col-xl-3 card">
            <a
                href={
                    content.homepageUrl +
                    content.employerDetailPage +
                    '/' +
                    content.segmentName +
                    '/'
                }
                title={content.name}
            >
                <article className="card__content">
                    <div className="img">
                        <img src={content.logoUrl} alt="" />
                    </div>
                    <div className="description">
                        <h2>{content.name}</h2>
                    </div>
                </article>
            </a>
        </div>
    );
}
